import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Pabrik.css"; // Perbaikan path import CSS di sini
import axios from "axios";

const UserProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [tanggal, setTanggal] = useState("");

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Fetch the user profile data from the backend
    axios
      .get("https://c-greenproject.org:7500/me", { withCredentials: true })
      .then((response) => {
        setUserInfo(response.data.profile || {});
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching profile data:", error);
        setLoading(false);
      });
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5 bg-light min-vh-100 d-flex flex-column justify-content-center align-items-center">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted mt-2">Memuat profil pengguna...</p>
      </div>
    );
  }

  const renderSidebarItems = () => {
    switch (userInfo.role) {
      case "kebun":
        return (
          <>
            <div
              onClick={() => navigate("/kebun")}
              className={`list-group-item text-decoration-none ${location.pathname === "/kebun" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/KebunP")}
              className={`list-group-item text-decoration-none ${location.pathname === "/KebunP" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" /> Petani
            </div>
            <div
              onClick={() => navigate("/kebunL")}
              className={`list-group-item text-decoration-none ${location.pathname === "/kebunL" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/shipping.png" alt="Logistics" /> Logistik
            </div>
            <div
              onClick={() => navigate("/kebunpabrik")}
              className={`list-group-item text-decoration-none ${location.pathname === "/kebunpabrik" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/factory.png" alt="Factory" /> Pabrik
            </div>
          </>
        );
      case "petani":
        return (
          <>
            <div
              onClick={() => navigate("/petani")}
              className={`list-group-item text-decoration-none ${location.pathname === "/petani" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/petanirt")}
              className={`list-group-item text-decoration-none ${location.pathname === "/petanirt" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" /> Rencana Tanam
            </div>
            <div
              onClick={() => navigate("/petanirp")}
              className={`list-group-item text-decoration-none ${location.pathname === "/petanirp" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/panen.png" alt="Harvest" /> Rencana Panen
            </div>
            <div
              onClick={() => navigate("/petanifp")}
              className={`list-group-item text-decoration-none ${location.pathname === "/petanifp" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/FinalPanen.png" alt="Final Panen" /> Final Panen
            </div>
            <div
              onClick={() => navigate("/petanip")}
              className={`list-group-item text-decoration-none ${location.pathname === "/petanip" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/sell_8087698.png" alt="Sales" /> Penjualan
            </div>
          </>
        );
      case "logistik":
        return (
          <>
            <div
              onClick={() => navigate("/logistik")}
              className={`list-group-item text-decoration-none ${location.pathname === "/logistik" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/logistikp")}
              className={`list-group-item text-decoration-none ${location.pathname === "/logistikp" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/shipping.png" alt="Shipping" /> Pengiriman
            </div>
            <div
              onClick={() => navigate("/logistikrp")}
              className={`list-group-item text-decoration-none ${location.pathname.includes("/logistikrp") ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/panen.png" alt="Harvest" /> Rencana Panen
            </div>
          </>
        );
      case "pabrik":
        return (
          <>
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none ${location.pathname === "/pabrik" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/pabrikt")}
              className={`list-group-item text-decoration-none ${location.pathname === "/pabrikt" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/shipping.png" alt="Planting" /> Transaksi
            </div>
            <div
              onClick={() => navigate("/pabrikh")}
              className={`list-group-item text-decoration-none ${location.pathname === "/pabrikh" ? "active text-white" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/packaging.png" alt="Harvest" /> Hasil
            </div>
          </>
        );
      default:
        return (
          <div className="list-group-item text-decoration-none" style={{ cursor: "pointer" }}>
            <img src="/static/guest.png" alt="Guest" /> Welcome, Guest
          </div>
        );
    }
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span id="user-role" className="fw-medium text-white">
            {userInfo.nama || "Pengguna"} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3">
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush">
            {renderSidebarItems()}
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Profil Pengguna</h2>
              <p className="text-muted small mb-0">Informasi detail akun dan hak akses Anda di dalam sistem.</p>
            </div>
          </div>

          <div className="divider mb-4"></div>

          {/* Profile Card Container */}
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="content-box p-5 border-0 shadow-sm rounded-4 bg-white text-start position-relative overflow-hidden">
                
                {/* Decorative header badge */}
                <div className="d-flex align-items-center mb-4 pb-3 border-bottom">
                  <div className="bg-success-subtle text-success p-3 rounded-circle me-3 shadow-sm">
                    <i className="fa fa-user-circle fs-2"></i>
                  </div>
                  <div>
                    <h4 className="fw-bold text-dark mb-1">{userInfo.nama || "-"}</h4>
                    <span className="badge bg-success text-white px-3 py-1 rounded-pill text-uppercase small">
                      {userInfo.role || "Role"}
                    </span>
                  </div>
                </div>

                {/* Profile Details Grid */}
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="p-3 bg-light rounded-3 border">
                      <span className="text-muted small d-block mb-1">Username</span>
                      <h6 className="fw-bold text-dark mb-0 font-monospace">{userInfo.username || "-"}</h6>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="p-3 bg-light rounded-3 border">
                      <span className="text-muted small d-block mb-1">Nomor HP</span>
                      <h6 className="fw-bold text-dark mb-0 font-monospace">{userInfo.nomor_hp || "-"}</h6>
                    </div>
                  </div>

                  {userInfo.role === "kebun" && (
                    <div className="col-12">
                      <div className="p-3 bg-light rounded-3 border">
                        <span className="text-muted small d-block mb-1">Alamat Kebun</span>
                        <h6 className="fw-bold text-dark mb-0">{userInfo.alamat_kebun || "-"}</h6>
                      </div>
                    </div>
                  )}

                  {userInfo.role === "petani" && (
                    <div className="col-12">
                      <div className="p-3 bg-light rounded-3 border">
                        <span className="text-muted small d-block mb-1">Alamat Rumah</span>
                        <h6 className="fw-bold text-dark mb-0">{userInfo.alamat_rumah || "-"}</h6>
                      </div>
                    </div>
                  )}

                  {userInfo.role === "logistik" && (
                    <div className="col-12">
                      <div className="p-3 bg-light rounded-3 border">
                        <span className="text-muted small d-block mb-1">Alamat</span>
                        <h6 className="fw-bold text-dark mb-0">{userInfo.alamat || "-"}</h6>
                      </div>
                    </div>
                  )}

                  {userInfo.role === "pabrik" && (
                    <>
                      <div className="col-12">
                        <div className="p-3 bg-light rounded-3 border">
                          <span className="text-muted small d-block mb-1">Alamat Pabrik</span>
                          <h6 className="fw-bold text-dark mb-0">{userInfo.alamat_pabrik || "-"}</h6>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-3 bg-light rounded-3 border">
                          <span className="text-muted small d-block mb-1">Kapasitas Penyimpanan</span>
                          <h6 className="fw-bold text-dark mb-0 font-monospace">{userInfo.kapasitas_penyimpanan || "-"}</h6>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-3 bg-light rounded-3 border">
                          <span className="text-muted small d-block mb-1">Kapasitas Produksi</span>
                          <h6 className="fw-bold text-dark mb-0 font-monospace">{userInfo.kapasitas_produksi || "-"}</h6>
                        </div>
                      </div>
                    </>
                  )}
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UserProfile;